/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PostDistributorImageSuccessResponseData,
    PostDistributorImageSuccessResponseDataFromJSON,
    PostDistributorImageSuccessResponseDataFromJSONTyped,
    PostDistributorImageSuccessResponseDataToJSON,
} from './PostDistributorImageSuccessResponseData';

/**
 * POST /distributors/image
 * @export
 * @interface PostDistributorImageSuccessResponse
 */
export interface PostDistributorImageSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof PostDistributorImageSuccessResponse
     */
    status: number;
    /**
     * エラーメッセージ。原則英語。
     * @type {string}
     * @memberof PostDistributorImageSuccessResponse
     */
    message: string;
    /**
     * 
     * @type {PostDistributorImageSuccessResponseData}
     * @memberof PostDistributorImageSuccessResponse
     */
    data: PostDistributorImageSuccessResponseData;
}

export function PostDistributorImageSuccessResponseFromJSON(json: any): PostDistributorImageSuccessResponse {
    return PostDistributorImageSuccessResponseFromJSONTyped(json, false);
}

export function PostDistributorImageSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostDistributorImageSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PostDistributorImageSuccessResponseDataFromJSON(json['data']),
    };
}

export function PostDistributorImageSuccessResponseToJSON(value?: PostDistributorImageSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PostDistributorImageSuccessResponseDataToJSON(value.data),
    };
}

